import { render, staticRenderFns } from "./BackendFlashMessage.vue?vue&type=template&id=1e1729ed&"
import script from "./BackendFlashMessage.vue?vue&type=script&lang=ts&"
export * from "./BackendFlashMessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports